import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

export default function PaymentMethods(props) {
  //const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [PaymentMethods, setPaymentMethods] = React.useState([]);
  const [sports, setSports] = React.useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(2);
  useEffect(() => {
    // Change for server api address
    GetPaymentMethods();
    //GetSports();
  }, []);

  const GetPaymentMethods = () => {
    console.log("PROPS PaymentMethod ======>", props);
    let url = process.env.REACT_APP_API2_URL + "/Player/PaymentMethod_GetList";

    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {
      console.log("PROPS======PaymentMethod REST THEN>", response.data);
      setPaymentMethods(response.data);
    });
  };

  /*Select Functions*/

  const handleMethodChange = (event) => {
    props.setIdMethodMem(event.target.value);
    setSelectedPaymentMethod(event.target.value);
  };

  const selectRowProp = {
    mode: "checkbox",
  };
  /*End Select Functions*/

  return (
    <React.Fragment>
      <FormControl
        className={`${classes.formControl} w-full`}
        size="small"
        variant="outlined"
      >
        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
          PaymentMethod
        </InputLabel>
        {console.log("in PaymentMethod RENDERING SELeCT")}
        {PaymentMethods && (
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            value={selectedPaymentMethod}
            onChange={handleMethodChange}
            displayEmpty
          >
            {PaymentMethods.map((PaymentMethod) => (
              <MenuItem
                /*key={PaymentMethod.NumberOfPaymentMethod}*/ value={
                  PaymentMethod.idPaymentMethod
                }
              >
                {PaymentMethod.paymentMethodName}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
    </React.Fragment>
  );
}
